import { authRoles } from "../../../auth/authRoles";
import DetailSHE from "./DetailSHE";
import EditSHE from "./EditSHE";
import SHE from "./SHE";
import TambahSHE from "./TambahSHE";

const sheRoutes = [
  {
    path: "/aktifitas_she/detail/:id",
    exact: true,
    component: DetailSHE,
    auth: authRoles.all,
  },
  {
    path: "/aktifitas_she/edit/:id",
    exact: true,
    component: EditSHE,
    auth: authRoles.all,
  },
  {
    path: "/aktifitas_she/tambah",
    exact: true,
    component: TambahSHE,
    auth: authRoles.all,
  },
  {
    path: "/aktifitas_she",
    exact: true,
    component: SHE,
    auth: authRoles.all,
  },
];

export default sheRoutes;
